// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"22a31ec9","165":"efdb86f8","213":"48d64726","263":"d1e7a954","654":"4937fec1","719":"c4259b33"}[chunkId] + ".chunk.js";
};